import { crossSellEvidenceLines } from './crossSellEvidenceLines';
import { discountLeakEvidenceLines } from './discountLeakEvidenceLines';
import { recurringAdhocEvidenceLines } from './recurringAdhocEvidenceLines';
import { stalePriceEvidenceLines } from './stalePriceEvidenceLines';
export const opportunityEvidenceLines = (opportunity, texts, locale)=>{
    switch(opportunity.kind){
        case 'stale_price':
            return stalePriceEvidenceLines(opportunity.evidence, texts.stalePrice, locale);
        case 'recurring_adhoc':
            return recurringAdhocEvidenceLines(opportunity.evidence, texts.recurringAdhoc, locale);
        case 'cross_sell':
            return crossSellEvidenceLines(opportunity.evidence, texts.crossSell, locale);
        case 'discount_leak':
            return discountLeakEvidenceLines(opportunity.evidence, texts.discountLeak, locale);
    }
};
